const siteRoute = process.env.GATSBY_URL;

function toPlainText(blocks = []) {
  return blocks
    ?.map((block: { _type: string; children: any }) => {
      if (block._type !== "block" || !block.children) {
        return "";
      }
      return block.children.map((child: { text: any }) => child.text).join("");
    })
    .join("\n\n");
}

export const ProductSchema = (
  main: {
    title: string;
    productDescription?: [];
    mainImage?: {
      asset: {
        url: string;
      };
    };
    slug: {
      current: string;
    };
  },
  shopify: {
    defaultVariant: {
      sku: string;
      price: string;
    };
  },
  reviews: any, 
  meta,
) => {

  const schema = {
    "@context": "https://schema.org/",
    "@type": "Product",
    name: meta?.metaTitle,
    image: meta?.ogImage,
    description:
      meta?.metaDescription,
    sku: shopify.defaultVariant.sku,
    brand: {
      "@type": "Brand",
      name: "Groove",
    },
    offers: {
      "@type": "Offer",
      url: `${siteRoute}/products/${main.slug.current}`,
      priceCurrency: (process.env.GATSBY_CURRENCY_SYMBOL == "$") ? "USD" : "GBP",
      price: shopify.defaultVariant.price,
      itemCondition: "https://schema.org/NewCondition",
      availability: "https://schema.org/InStock",
    },
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: reviews?.rating,
      ratingCount: reviews?.totalReviews,
      bestRating:5,
      worstRating: 1
    }
  };

  return schema;
};
